import { platform } from 'os';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import useSWRImmutable from 'swr/immutable';
import { useFormik } from 'formik';
import { createServer, pollServer } from '../../../api/server';
import { COOKIE } from '../../../constants';
import { TidalButton } from '../../common/button';
import TidalCheckbox from '../../common/button/TidalCheckbox';
import TidalDropdown from '../../common/dropdown/TidalDropdown';
import TidalCountInput from '../../common/input/TidalCountInput';
import TidalInputField from '../../common/input/TidalInputField';
import TidalSuffixInputField from '../../common/input/TidalSuffixInputField';
import { Box } from '../../Flex';
import Loading from '../../Loading';
import AWS from '../../svgs/AWS';
import GCP from '../../svgs/GCP';
import Upload from '../../svgs/Upload';
import { instanceTypes } from './instaceData';
import { operatingSystems } from './operatingSystems';
import { regions } from './regions';
import TidalDashboardServerProdiverSelect from './TidalDashboardServerProdiverSelect';
import moment from 'moment';
import useSWR from 'swr';

const TidalDashbaordAddNewServerModalWrapper = styled.div`
  padding: 23px 27px;
  box-shadow: 0px 26px 87px rgba(27, 31, 38, 0.25);
  border-radius: 14px;
  background-color: ${(props) => props.theme.colors.background};
  width: 1548px;
  max-width: 100%;
  overflow: auto;
  @media only screen and (max-width: 1000px) {
    height: 90vh;
  }
`;

const TidalDashbaordAddNewServerModalTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
`;

const TidalDashboardAddNewServerModalTitle = styled.p`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: ${(props) => props.theme.colors.text[1]};
`;

const TidalDashboardAddNewServerRequired = styled.div`
  position: relative;

  & > p {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: ${(props) => props.theme.colors.text[0]};
  }
  & > span {
    position: absolute;
    left: -10px;
    bottom: -4px;
    color: ${(props) => props.theme.colors.text[3]};
  }
`;

const TidalDashboardAddNewServerModalSubTitle = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.text[1]};
  margin-bottom: 2px;
  position: relative;
  & > span {
    font-size: 14px;
    line-height: 17px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    color: ${(props) => props.theme.colors.accent};
  }
`;

const TidalDashboardAddNewServerModalText = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => props.theme.colors.text[0]};
`;

const TidalDashboardAddNewServerModalRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 24px;

  & > div:nth-child(1) {
    padding-right: 24px;
  }
  & > div:nth-child(2) {
    padding-left: 24px;
    border-left: 1px solid ${(props) => props.theme.colors.borderColors[0]};
    padding-right: 24px;
  }
  & > div:nth-child(3) {
    padding-left: 24px;
    border-left: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  }
  @media only screen and (max-width: 1000px) {
    display: block;
    & > div {
      border: none !important;
      padding: 0 !important;
      margin-bottom: 24px;
      padding-bottom: 24px !important;
      border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[0]} !important;
    }
    & > div:nth-child(3) {
      border: none !important;
      padding: 0 !important;
    }
  }
`;

const TidalDashboardAddNewServerCredentialsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
`;

const TidalDashboardAddNewServerModalFooter = styled.div`
  margin-top: 24px;
  padding-top: 26px;
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  display: grid;
  grid-template-columns: 125px 214px;
  justify-content: flex-end;
  grid-gap: 16px;
  @media only screen and (max-width: 400px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

const TidalDashboardAddNewServerImageContainer = styled.div`
  position: relative;
  & > .obstruct {
    position: absolute;
    height: 100%;
    width: 100%;
  }
`;

const TidalDashboardAddApplicationsContainer = styled.div`
  opacity: 0.5;
  position: relative;
  & > .obstruct {
    position: absolute;
    height: 100%;
    width: 100%;
    cursor: not-allowed;
  }
`;

const TidalDashboardAddApplicationsListContainer = styled.div`
  max-height: 240px;
  overflow-x: scroll;
  position: relative;
`;

const TidalDashboardAddNewServerImageRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;
  @media only screen and (max-width: 400px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

const TidalDashboardAddNewServerImage = styled.div`
  border-radius: 10px;
  height: 42px;
  border: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => props.theme.colors.text[0]};
`;

const TidalDashboardAddNewServerAutoDestroyRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 86px 86px 86px;
  grid-gap: 12px;
  @media only screen and (max-width: 400px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }
`;

const TidalDashboardAddNewServerDestroyPeriod = styled.div`
  border-radius: 10px;
  height: 42px;
  border: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  background-color: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.text[0]};
`;

const TidalDashboardAddNewServerDestroyPeriodButton = styled.button<{
  isActive: boolean;
}>`
  border-radius: 10px;
  height: 42px;
  border: 2px solid
    ${(props) =>
      !props.isActive
        ? props.theme.colors.borderColors[1]
        : props.theme.colors.accent};
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => props.theme.colors.text[0]};
`;

interface ITidalDashboardAddNewServerModal {
  onClose: () => void;
  onCreated: (data: any) => void;
  snapshots: any;
}

interface MyFormValues {
  instanceName: string;
  username: string;
  password: string;
  storageAmount: number;
  quantity: number;
}

const TidalDashbaordAddNewServerModal = ({
  onClose,
  onCreated,
  snapshots,
}: ITidalDashboardAddNewServerModal): JSX.Element => {
  const [serverProviders, setServerProviders] = useState([
    { name: 'aws', index: 0, icon: <AWS />, isSelected: true, isAdded: false },
    { name: 'gcp', index: 1, icon: <GCP />, isSelected: false, isAdded: false },
  ]);

  const [isSaving, setIsSaving] = useState(false);
  const [operatingSystem, setOperatingSystem] = useState('');
  const [ami, setAMI] = useState('');
  const [region, setRegion] = useState('');
  const [instanceType, setInstanceType] = useState('');
  const [networkName, setNetworkName] = useState('');
  const [destroyAt, setDestroyAt] = useState(null);
  const [destroyType, setDestroyType] = useState(-1);
  const [disableSecurity, setDisableSecurity] = useState(false);
  const [createError, setCreateError] = useState(null);
  const [snapshot, setSnapshot] = useState(null);

  const handleServerProviderSelect = (item) => {
    let tempServerProviders = [...serverProviders];
    serverProviders.forEach((s) => {
      if (s.index == item.index) {
        tempServerProviders[s.index].isSelected = true;
      } else {
        tempServerProviders[s.index].isSelected = false;
      }
    });
    setSnapshot(null);
    setServerProviders(tempServerProviders);
  };

  useEffect(() => {
    setRegion(regions[serverProviders.find((s) => s.isSelected).name][0]);
    setInstanceType(
      instanceTypes[serverProviders.find((s) => s.isSelected)?.name][0].type,
    );
    setOperatingSystem(
      operatingSystems[serverProviders.find((s) => s.isSelected).name][0].name,
    );
    setAMI(
      operatingSystems[serverProviders.find((s) => s.isSelected).name][0].ami,
    );
  }, [serverProviders]);

  const handleCreateServer = async (values: MyFormValues) => {
    let serverDestroyAt = null;
    if (destroyAt != null && destroyAt > 0) {
      switch (destroyType) {
        case 0:
          serverDestroyAt = moment(new Date()).add(destroyAt, 'minute');
          break;
        case 1:
          serverDestroyAt = moment(new Date()).add(destroyAt, 'hour');
          break;
        case 2:
          serverDestroyAt = moment(new Date()).add(destroyAt, 'day');
          break;
      }
    }

    setIsSaving(true);
    setCreateError(null);
    try {
      let res = await createServer({
        platform: serverProviders.find((s) => s.isSelected).name,
        region,
        ami,
        instanceType,
        quantity: values.quantity,
        user: values.username,
        pass: values.password,
        disableSecurity,
        storage: values.storageAmount,
        name: values.instanceName,
        operatingSystem,
        networkName,
        destroyAt: serverDestroyAt?.toDate().toISOString() || null,
        snapshotProviderId: snapshot?.providerId,
      });
      if (res[0].instanceId && res[0].id) {
        onCreated({
          response: res,
          provider: serverProviders.find((s) => s.isSelected).name,
          user: values.username,
          pass: values.password,
        });
        onClose();
      }
    } catch (e) {
      console.error(e);
      if (e.message) {
        setCreateError(e.message);
      } else {
        setCreateError('Failed to create server');
      }
    }
    setIsSaving(false);
  };

  const {
    data,
    error: err,
    isValidating,
    mutate,
  } = useSWRImmutable('/dashboard/servers/credentials');

  useEffect(() => {
    if (data?.awsCredential && data?.gcpCredential) {
      setServerProviders([
        {
          name: 'aws',
          index: 0,
          icon: <AWS />,
          isSelected: true,
          isAdded: true,
        },
        {
          name: 'gcp',
          index: 1,
          icon: <GCP />,
          isSelected: false,
          isAdded: true,
        },
      ]);
    } else if (data?.awsCredential && !data?.gcpCredential) {
      setServerProviders([
        {
          name: 'aws',
          index: 0,
          icon: <AWS />,
          isSelected: true,
          isAdded: true,
        },
        {
          name: 'gcp',
          index: 1,
          icon: <GCP />,
          isSelected: false,
          isAdded: false,
        },
      ]);
    } else if (!data?.awsCredential && data?.gcpCredential) {
      setServerProviders([
        {
          name: 'aws',
          index: 0,
          icon: <AWS />,
          isSelected: true,
          isAdded: false,
        },
        {
          name: 'gcp',
          index: 1,
          icon: <GCP />,
          isSelected: false,
          isAdded: true,
        },
      ]);
    }
  }, [data?.awsCredential, data?.gcpCredential]);

  const validate = (values: MyFormValues) => {
    const errors: any = {};

    if (!values.instanceName) {
      errors.instanceName = 'Required';
    }

    if (values.username.length < 8) {
      errors.username = 'Must be 8 or more characters';
    }
    if (values.username === values.instanceName) {
      errors.username = 'Cannot match instance name';
    }
    if (!values.username) {
      errors.username = 'Required';
    }

    if (!values.password) {
      errors.password = 'Required';
    }
    if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
        values.password,
      )
    ) {
      errors.password =
        'Must contain 8 chars including special char and number';
    }

    if (!values.storageAmount) {
      errors.storageAmount = 'Required';
    }
    if (values.storageAmount < 50) {
      errors.storageAmount = 'Storage should be 50GB or more';
    }

    if (!values.quantity) {
      errors.quantity = 'Required';
    }
    if (values.quantity < 1) {
      errors.quantity = 'Quantity should be atleast 1';
    }
    if (values.quantity > 5) {
      errors.quantity = 'Quantity should be atmost 5';
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      instanceName: '',
      username: '',
      password: '',
      storageAmount: 50,
      quantity: 1,
    },
    validate,
    // validateOnMount: false,
    isInitialValid: false,
    onSubmit: (values) => {},
  });

  const provider = serverProviders.find((s) => s.isSelected).name;
  const filteredSnapshots = snapshots.filter(
    (snapshot) => snapshot.provider === provider && snapshot.state === 'active',
  );

  if (isValidating) return <Loading />;

  return (
    <TidalDashbaordAddNewServerModalWrapper>
      <TidalDashbaordAddNewServerModalTitleRow>
        <TidalDashboardAddNewServerModalTitle>
          Generate New Server
        </TidalDashboardAddNewServerModalTitle>
        <TidalDashboardAddNewServerRequired>
          <p>Required Field</p>
          <span>*</span>
        </TidalDashboardAddNewServerRequired>
      </TidalDashbaordAddNewServerModalTitleRow>
      <TidalDashboardAddNewServerModalRow>
        <div>
          <TidalDashboardAddNewServerModalSubTitle>
            Personalization
          </TidalDashboardAddNewServerModalSubTitle>
          <TidalInputField
            isRequired={true}
            label="Give your instance a name"
            placeholder="Enter name"
            name="instanceName"
            value={formik.values.instanceName}
            onBlur={(e: any) => {
              formik.handleBlur(e);
            }}
            onChange={(e: any) => {
              formik.handleChange(e);
            }}
          />
          {formik.touched.instanceName && (
            <p className="tidal-error">{formik.errors.instanceName}</p>
          )}

          <Box height={16} />
          <TidalDashboardAddNewServerModalSubTitle>
            Provider
          </TidalDashboardAddNewServerModalSubTitle>
          <TidalDashboardServerProdiverSelect
            label="Select provider to generate server"
            isRequired={true}
            items={serverProviders}
            onSelect={(e) => {
              handleServerProviderSelect(e);
            }}
          />
          <Box height={16} />

          <TidalDropdown
            isRequired={true}
            label="Region"
            defaultValue={
              regions[serverProviders.find((s) => s.isSelected).name][0]
            }
            items={regions[serverProviders.find((s) => s.isSelected).name]}
            onSelect={(item) => {
              setRegion(item);
            }}
          />
          <Box height={16} />
          <TidalDashboardAddNewServerModalSubTitle>
            Credentials
          </TidalDashboardAddNewServerModalSubTitle>
          <TidalDashboardAddNewServerCredentialsRow>
            <div>
              <TidalInputField
                isRequired={false}
                label="Username (atleast 8 chars)"
                placeholder="Enter Username"
                name="username"
                value={formik.values.username}
                onBlur={(e) => formik.handleBlur(e)}
                disabled={!!snapshot}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />

              {formik.touched.username && (
                <p className="tidal-error">{formik.errors.username}</p>
              )}
            </div>
            <div>
              <TidalInputField
                isRequired={false}
                label="Password"
                placeholder="Enter password"
                type="password"
                name="password"
                value={formik.values.password}
                onBlur={(e) => formik.handleBlur(e)}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {formik.touched.password && (
                <p className="tidal-error">{formik.errors.password}</p>
              )}
            </div>
          </TidalDashboardAddNewServerCredentialsRow>
        </div>
        <div>
          <TidalDashboardAddNewServerModalSubTitle>
            Compute
          </TidalDashboardAddNewServerModalSubTitle>
          <TidalDashboardAddNewServerModalText>
            Select the desired compute configuration
          </TidalDashboardAddNewServerModalText>
          <Box height={13} />
          <TidalDropdown
            isRequired={true}
            label="Select Type"
            defaultValue={
              instanceTypes[serverProviders.find((s) => s.isSelected)?.name][0]
                .type
            }
            items={instanceTypes[
              serverProviders.find((s) => s.isSelected)?.name
            ]?.map((i) => i.type)}
            onSelect={(item) => {
              setInstanceType(item);
            }}
          />
          <Box height={16} />

          <TidalDropdown
            isRequired={true}
            label="Operating System"
            defaultValue={
              operatingSystems[
                serverProviders.find((s) => s.isSelected).name
              ][0].name
            }
            items={operatingSystems[
              serverProviders.find((s) => s.isSelected).name
            ].map((o) => o.name)}
            onSelect={(item) => {
              setOperatingSystem(
                operatingSystems[
                  serverProviders.find((s) => s.isSelected).name
                ].find((o) => o.name == item).name,
              );
              setAMI(
                operatingSystems[
                  serverProviders.find((s) => s.isSelected).name
                ].find((o) => o.name == item).ami,
              );
            }}
          />

          <Box height={16} />
          <div>
            <TidalSuffixInputField
              label="Storage Amount"
              isRequired={true}
              suffix="GB"
              placeholder="0"
              type="number"
              value={formik.values.storageAmount.toString()}
              name="storageAmount"
              onBlur={(e) => {
                formik.handleBlur(e);
              }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {formik.touched.storageAmount && (
              <p className="tidal-error">{formik.errors.storageAmount}</p>
            )}
          </div>

          <Box height={16} />
          <TidalDashboardAddNewServerModalSubTitle>
            Quantity
          </TidalDashboardAddNewServerModalSubTitle>
          <div>
            <TidalCountInput
              label="Select the desired amount of servers"
              placeholder="0"
              value={formik.values.quantity.toString()}
              name="quantity"
              onBlur={(e) => formik.handleBlur(e)}
              onAction={async (e) => {
                try {
                  await formik.setFieldTouched('quantity');
                  await formik.setFieldValue('quantity', parseInt(e), true);
                  await formik.validateField('quantity');
                } catch (e) {
                  console.log(e);
                }
              }}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {formik.touched.quantity && (
              <p className="tidal-error">{formik.errors.quantity}</p>
            )}
          </div>
          <Box height={16} />
          <TidalDashboardAddNewServerModalSubTitle>
            Auto Destroy
          </TidalDashboardAddNewServerModalSubTitle>
          <div>
            {/* <div className="obstruct" /> */}
            <TidalDashboardAddNewServerModalText>
              Destroy server after period
            </TidalDashboardAddNewServerModalText>
            <Box height={8} />
            <TidalDashboardAddNewServerAutoDestroyRow>
              <TidalInputField
                label=""
                placeholder="Time"
                onChange={(e) => {
                  setDestroyAt(e.target.value);
                }}
              />
              <TidalDashboardAddNewServerDestroyPeriodButton
                isActive={destroyType == 0}
                onClick={() => setDestroyType(0)}
              >
                Min
              </TidalDashboardAddNewServerDestroyPeriodButton>
              <TidalDashboardAddNewServerDestroyPeriodButton
                isActive={destroyType == 1}
                onClick={() => setDestroyType(1)}
              >
                Hour
              </TidalDashboardAddNewServerDestroyPeriodButton>
              <TidalDashboardAddNewServerDestroyPeriodButton
                isActive={destroyType == 2}
                onClick={() => setDestroyType(2)}
              >
                Day
              </TidalDashboardAddNewServerDestroyPeriodButton>
            </TidalDashboardAddNewServerAutoDestroyRow>
          </div>
        </div>
        <div>
          <TidalDashboardAddNewServerModalSubTitle>
            Server Image
          </TidalDashboardAddNewServerModalSubTitle>
          <TidalDashboardAddNewServerImageContainer>
            <div className="obstruct" />
            <TidalDashboardAddNewServerModalText>
              Restore a saved server
            </TidalDashboardAddNewServerModalText>
            <Box height={8} />

            <TidalDropdown
              isRequired={false}
              label="Select Snapshot"
              defaultValue={'None'}
              items={filteredSnapshots.map((snapshot) => snapshot.name)}
              onSelect={(item, i) => {
                setSnapshot(filteredSnapshots[i]);
                formik.setFieldValue(
                  'username',
                  filteredSnapshots[i]?.server?.username,
                );
              }}
            />
          </TidalDashboardAddNewServerImageContainer>

          <Box height={21} />
          <TidalDashboardAddNewServerModalSubTitle>
            Install Apps
            <span>Coming soon</span>
          </TidalDashboardAddNewServerModalSubTitle>
          <TidalDashboardAddApplicationsContainer>
            <div className="obstruct" />
            <TidalDashboardAddNewServerModalText>
              Select the applications you want installed
            </TidalDashboardAddNewServerModalText>
            <TidalDashboardAddApplicationsListContainer>
              <Box height={16} />
              <TidalCheckbox text="Google chrome" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Discord" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="ANB AIO" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Cybersole" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Burst AIO" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Dashe" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Prism" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Koi AIO" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Project Destroyer" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Dragon AIO" isChecked={false} />
              <Box height={8} />
              <TidalCheckbox text="Balko" isChecked={false} />
              <Box height={8} />
            </TidalDashboardAddApplicationsListContainer>
          </TidalDashboardAddApplicationsContainer>
          <Box height={34} />
          <TidalCheckbox
            text="Disable server security"
            isChecked={disableSecurity}
            onClick={() => {
              setDisableSecurity((disableSecurity) => !disableSecurity);
            }}
          />
        </div>
      </TidalDashboardAddNewServerModalRow>
      <TidalDashboardAddNewServerModalFooter>
        <TidalButton
          text="Cancel"
          type="default"
          tint={true}
          onClick={onClose}
        />
        <TidalButton
          text="Create Server"
          type="info"
          tint={false}
          disabled={!formik.isValid || isSaving}
          isLoading={isSaving}
          onClick={() => {
            handleCreateServer(formik.values);
          }}
        />
      </TidalDashboardAddNewServerModalFooter>
      <div>
        {createError && (
          <p className="mt-4 text-right text-red-500">{createError}</p>
        )}
      </div>
    </TidalDashbaordAddNewServerModalWrapper>
  );
};

export default TidalDashbaordAddNewServerModal;
